import '../../../styles/templates/customers/account.scss';

window.addEventListener(
  'message',
  (event: MessageEvent) => {
    const frame: HTMLIFrameElement | null = document.querySelector('iframe.salesforce');
    if (!frame) return;
    const expectedHost = new URL(frame.src).host;
    if (event.origin.indexOf(expectedHost) === -1) {
      // we get tons of messages from adtech, o'ly, etc.
      return;
    }

    const object = JSON.parse(event.data);
    if (object.event === 'resize') {
      frame.style.height = object.height.toString() + 'px';
    }

    if (object.event === 'success') {
      frame.classList.add('inactive');
      const successMessage = document.querySelector('.successMessageContent');
      if (successMessage) successMessage.style.display = 'block';
    }
  },
  false
);
